import {toUiMsg$} from '@/ui';
import {toWsMsg$, wsOpened$} from '@/ws';
import {contractMarketRealtimeCache$} from './market24h-contract-cache';
import {contractMarket24hRealtime$} from './market-contract';
import {ContractMarket} from '@/types';

export interface UMarketContract {
  type: 'market24h-contract';
  data: Map<string, ContractMarket>;
}
export interface UMarketContractRealtime {
  type: 'market24h-contract-realtime';
  data: ContractMarket;
}

export function subscribeMarketContract() {
  wsOpened$.subscribe(() => {
    toWsMsg$.next({method: 'perp_market24h_pack.subscribe', params: []});
    toWsMsg$.next({method: 'perp_market24h_pack_p.subscribe', params: {}});
  });

  contractMarketRealtimeCache$.subscribe((data) => toUiMsg$.next({type: 'market24h-contract', data}));
  contractMarket24hRealtime$.subscribe((data) => toUiMsg$.next({type: 'market24h-contract-realtime', data}));
}
